// Ported verbatim from static/app.js companion-score helpers.
import type { CompanionAgentItem } from "../api/types";

export type CompanionScoreClass = "bullish" | "neutral" | "bearish" | "unavailable";

export function normalizeCompanionScore(rawScore: number | string | null | undefined): number | null {
  if (rawScore === null || rawScore === undefined || rawScore === "") {
    return null;
  }

  const score = Math.round(Number(rawScore));
  if (!Number.isFinite(score)) {
    return null;
  }

  return Math.max(0, Math.min(100, score));
}

export function companionScoreLabel(score: number | null): string {
  if (score === null) {
    return "Unavailable";
  }
  if (score <= 40) {
    return "Bearish";
  }
  if (score >= 60) {
    return "Bullish";
  }
  return "Neutral";
}

export function companionScoreClass(score: number | null): CompanionScoreClass {
  if (score === null) {
    return "unavailable";
  }
  if (score <= 40) {
    return "bearish";
  }
  if (score >= 60) {
    return "bullish";
  }
  return "neutral";
}

export function companionNeedleAngle(score: number | null): number {
  if (score === null) {
    return -135;
  }

  return -135 + score * 2.7;
}

export function companionTooltipBullets(item: CompanionAgentItem): string[] {
  const bullets = Array.isArray(item.bullets)
    ? item.bullets.map((bullet) => String(bullet).trim()).filter(Boolean)
    : [];

  if (bullets.length) {
    return bullets.slice(0, 4);
  }
  if (item.error) {
    return [item.error];
  }

  return ["No concise summary was returned."];
}
